import { useCallback, useMemo } from 'react';

import { useGetPublicServiceCatalogQuery, useGetServiceCatalogQuery } from '@shared/services/serviceCatalogs';

import useIsAuthenticated from '../useIsAuthenticated';

const useServiceCatalog = (skip: boolean) => {
  const { isAuthenticated } = useIsAuthenticated();

  const trustedQuery = useGetServiceCatalogQuery(undefined, {
    skip: !isAuthenticated || skip,
  });
  const publicQuery = useGetPublicServiceCatalogQuery(undefined, {
    skip: isAuthenticated || skip,
  });

  const activeQuery = isAuthenticated ? trustedQuery : publicQuery;
  const serviceCatalog = useMemo(() => activeQuery.data ?? [], [activeQuery.data]);

  const getService = useCallback((code: string) => serviceCatalog.find((s) => s.Code === code), [serviceCatalog]);

  return {
    getService,
    serviceCatalog,
    isFetching: activeQuery.isFetching,
    isLoading: activeQuery.isLoading,
    error: activeQuery.error,
  };
};

export default useServiceCatalog;
